import React from 'react';
import { Paper, Box, Typography } from '@mui/material';

import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SummarizeIcon from '@mui/icons-material/Summarize';

const ChanceStepDescInfo = ({ chance }) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Paper sx={{ my: 0, p: 0 }} variant="outlined">

<Box sx={{ px: 2, py: 1, my: 1 }}>
  {/* 3열 2행 그리드 레이아웃 */}
  <Box sx={{ 
    display: 'grid', 
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 1,
    py: 1
  }}>
    {/* 첫 번째 행 */}
    <Box sx={{ textAlign: 'center', borderBottom: 1, borderColor: 'divider', pb: 1 }}>
      <Typography variant="caption" component="div" color="text.secondary">매출처</Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 'medium' }}>
        {chance?.vendorCmpNm || '-'}
      </Typography>
    </Box>
    
    <Box sx={{ textAlign: 'center', borderBottom: 1, borderColor: 'divider', pb: 1 }}>
      <Typography variant="caption" component="div" color="text.secondary">고객사</Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 'medium' }}>
        {chance?.customerNm || '-'}
      </Typography>
    </Box>
    
    <Box sx={{ textAlign: 'center', borderBottom: 1, borderColor: 'divider', pb: 1 }}>
      <Typography variant="caption" component="div" color="text.secondary">매출 예상일</Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 'medium' }}>
        {chance?.expDay || '-'}
      </Typography>
    </Box>

    {/* 두 번째 행 */}
    <Box sx={{ textAlign: 'center', pt: 1 }}>
      <Typography variant="caption" component="div" color="text.secondary">매출액</Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 'medium' }}>
        {chance?.expSales ? `${Number(chance.expSales).toLocaleString()}원` : '-'}
      </Typography>
    </Box>
    
    <Box sx={{ textAlign: 'center', pt: 1 }}>
      <Typography variant="caption" component="div" color="text.secondary">매출 이익</Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 'medium' }}>
        {chance?.totalProfit ? `${Number(chance.totalProfit).toLocaleString()}원` : '-'}
      </Typography>
    </Box>
    
    <Box sx={{ textAlign: 'center', pt: 1 }}>
      <Typography variant="caption" component="div" color="text.secondary">예상 이익률</Typography>
      <Typography variant="body2" component="div" sx={{ fontWeight: 'medium' }}>
        {chance?.expBenefitRate}%
      </Typography>
    </Box>
  </Box>
</Box>

    </Paper>
  );
};

export default ChanceStepDescInfo;
